<!-- File type and size info -->
<div class="file-info-container" *ngIf="showFileTypeInfo">
  <span class="file-info-text">
    {{ T.common.max_file_size_with_size | translate: { maxFileSize: getMaxFileSizeDisplay() } }} | {{ T.common.only_image_attachments_allowed | translate }}
  </span>
</div>

<div class="upload-container" [class.has-attachments]="!showLabel" tabindex="0">
  <ng-container *ngIf="loading || externalLoading">
    <app-loading [displayLogo]="true"> {{ T.settings.imports_and_exports.uploading_your_file | translate}} </app-loading>
  </ng-container>
  <input #file type="file" [name]="'file-' + globalObjectId" class="inputfile" (change)="onSelectFile(file.files)" multiple/>
  <!-- Label with drag and drop enabled -->
  <label *ngIf="!shouldDisableDragAndDrop"
         appDragDrop
         (dropHandler)="onDropHandler($event)"
         [allowedTypes]="allowedTypes"
         [maxFiles]="maxFiles"
         [class.drag-hover]="isDragOver">
    <i class="material-symbols-outlined" *ngIf="showLabel"> cloud_upload </i>
    <ng-container *ngIf="isNativePlatform">
      <span class="title" *ngIf="showLabel">{{ T.common.take_photo_or_upload_file | translate }}</span>
      <span class="span-btn" *ngIf="canAddFile" (click)="takePhoto()">{{ T.common.take_a_photo | translate }}</span>
      <span class="span-btn" *ngIf="canAddFile" style="margin-left: 8px" (click)="openFileUpload()">
        {{ customButtonText || (T.common.browse | translate) }}
      </span>
      <span
        class="title"
        *ngIf="canAddLink && showLinkOption"
        [innerHTML]="T.common.or_add_a_link | translate"
        (click)="addLink()"
      ></span>
    </ng-container>
    <ng-container *ngIf="!isNativePlatform">
      <span class="title" *ngIf="showLabel">{{ T.common.drag_or_paste_files_here_to_upload | translate }}</span>
      <span class="title" *ngIf="showHelperText">{{ T.common.max_file_size_with_size | translate: { maxFileSize: getMaxFileSizeDisplay() } }}</span>
      <span class="span-btn" *ngIf="canAddFile" (click)="openFileUpload()">
        {{ customButtonText || (T.common.browse | translate) }}
      </span>
      <span class="title" (click)="addLink()" *ngIf="canAddLink && showLinkOption" [innerHTML]="T.common.or_add_a_link | translate">
      </span>
    </ng-container>
  </label>

  <!-- Label with drag and drop disabled -->
  <label *ngIf="shouldDisableDragAndDrop">
    <i class="material-symbols-outlined" *ngIf="showLabel"> cloud_upload </i>
    <ng-container *ngIf="isNativePlatform">
      <span class="title" *ngIf="showLabel">{{ T.common.take_photo_or_upload_file | translate }}</span>
      <span class="span-btn" *ngIf="canAddFile" (click)="takePhoto()">{{ T.common.take_a_photo | translate }}</span>
      <span class="span-btn" *ngIf="canAddFile" style="margin-left: 8px" (click)="openFileUpload()">
        {{ customButtonText || (T.common.browse | translate) }}
      </span>
      <span
        class="title"
        *ngIf="canAddLink && showLinkOption"
        [innerHTML]="T.common.or_add_a_link | translate"
        (click)="addLink()"
      ></span>
    </ng-container>
    <ng-container *ngIf="!isNativePlatform">
      <span class="title" *ngIf="showLabel">{{ T.common.browse | translate }} {{ T.common.files_to_upload | translate }}</span>
      <span class="title" *ngIf="showHelperText">{{ T.common.max_file_size_with_size | translate: { maxFileSize: getMaxFileSizeDisplay() } }}</span>
      <span class="span-btn" *ngIf="canAddFile" (click)="openFileUpload()">
        {{ customButtonText || (T.common.browse | translate) }}
      </span>
      <span class="title" (click)="addLink()" *ngIf="canAddLink && showLinkOption" [innerHTML]="T.common.or_add_a_link | translate">
      </span>
    </ng-container>
  </label>
</div>
